import { CreateProjectState } from '../../../domain/projectStatus/createProjectState';
import { UpdateProjectState } from '../../../domain/projectStatus/updateProjectState';
import { ProjectStatusAdapter } from '../../adapters/projectStatus/projectStatusAdapter';
import { ProjectStatusListDTO } from '../../http/dtos/projectStatus/ProjectStatusListDTO';
import { ProjectStatusDTO } from '../../http/dtos/projectStatus/projectStatusDTO';
import httpClient from '../../http/httpClient';

export const ProjectStatusRepository = {
    GetProjectStatusList: () => {
        return httpClient
            .get('/project-status/projects-status-filtered-list')
            .then((response: ProjectStatusListDTO[]) =>
                ProjectStatusAdapter.getProjectStatusListAdapter(response)
            );
    },

    GetProjectState: (id: string) => {
        return httpClient
            .get('/project-status/project-state-by-id/' + id)
            .then((response: ProjectStatusDTO) =>
                ProjectStatusAdapter.getProjectStatusAdapter(response)
            );
    },

    CreateProjectState: (newProjectState: CreateProjectState) => {
        return httpClient
            .post('/project-status', newProjectState)
            .then((response) => response);
    },

    UpdateProjectState: (newProjectState: UpdateProjectState, id: number) => {
        return httpClient
            .put('/project-status/update-project-state/' + id, newProjectState)
            .then((response) => response);
    },
};
